import ActionTypes from 'app/about/ActionTypes';
import reducer from 'app/about/reducer';
import routes from 'app/about/routes';

export default {
  routes,
  reducers: {
    about: reducer,
  },
  actionTypes: ActionTypes,
};
